import { render, staticRenderFns } from "./InvoiceInfoDetail.vue?vue&type=template&id=556dd036&scoped=true"
import script from "./InvoiceInfoDetail.vue?vue&type=script&lang=js"
export * from "./InvoiceInfoDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556dd036",
  null
  
)

export default component.exports